import * as Yup from 'yup';
import { emailValidation, passwordValidation } from '../../helpers';

export const validationSchema = Yup.object().shape({
  email: emailValidation(),
  password: passwordValidation(),
});
